import styled from "styled-components";
import { Container } from "../../common/styles";
import { theme } from "../../theme";

export const HeaderBlock = styled.header`
    background-color: ${theme.colors.colorfulBackground};
    background-image: url("./headerBackground.svg");
    background-size: cover;
    background-position: center;
    color: ${theme.colors.white};
    padding: 80px 7% 70px;
    width: 100%;
    @media (max-width:${theme.breakpoints.mobile}) {
        padding: 70px 20px 60px;
    }
`;

export const HeaderTitle = styled.h1`
    font-weight: ${theme.fonts.weights.superBold};
    font-size: 40px;
    @media (max-width:${theme.breakpoints.mobile}) {
        font-size: 30px;
    }
`;

export const StyledSection = styled(Container)`
    margin-top: 10px;
    min-height: 600px;
    background-position: center;
    background-size: cover;
    white-space: break-spaces;
    line-height: 1.3;
`;

export const ListElement = styled.li`
    margin: 13px 0;
`;

export const Description = styled.div`
    margin: 15px 0;
`;